/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type PERIODICITY = "DAILY" | "MONTHLY" | "WEEKLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_HOURS" | "FIXED_PRICE" | "TIME_AND_MATERIALS" | "%future added value";
export type UpdateRetainerPeriodInput = {
    id?: string | null | undefined;
    projectId?: string | null | undefined;
    name?: string | null | undefined;
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    endYear?: number | null | undefined;
    endMonth?: number | null | undefined;
    endDay?: number | null | undefined;
    periodPeriodicity?: PERIODICITY | null | undefined;
    periodLength?: number | null | undefined;
    periodBudgetType?: PERIOD_BUDGET_TYPE | null | undefined;
    periodHoursAmount?: number | null | undefined;
    periodPriceAmount?: number | null | undefined;
    periodSettingIgnoreForBilling?: boolean | null | undefined;
    periodSettingSubtractValue?: boolean | null | undefined;
    periodSettingRollValue?: boolean | null | undefined;
    periodSettingAddExpenses?: boolean | null | undefined;
    periodDifferenceHoursAmount?: number | null | undefined;
    periodDifferencePriceAmount?: number | null | undefined;
    ignoredRolloverHours?: number | null | undefined;
    ignoredRolloverPrice?: number | null | undefined;
    splitRollover?: boolean | null | undefined;
    periodLocked?: boolean | null | undefined;
    periodLockedTime?: string | null | undefined;
    pushPeriods?: boolean | null | undefined;
    rolloverIdsToRevert?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateRetainerPeriodMutationVariables = {
    input: UpdateRetainerPeriodInput;
};
export type updateRetainerPeriodMutationResponse = {
    readonly updateRetainerPeriod: {
        readonly errors: ReadonlyArray<string | null> | null;
        readonly retainerPeriod: {
            readonly id: string;
            readonly name: string | null;
            readonly startYear: number | null;
            readonly startMonth: number | null;
            readonly startDay: number | null;
            readonly endYear: number | null;
            readonly endMonth: number | null;
            readonly endDay: number | null;
            readonly available: number | null;
            readonly periodLength: number | null;
            readonly periodPeriodicity: PERIODICITY | null;
            readonly periodPriceAmount: number | null;
            readonly periodHoursAmount: number | null;
            readonly periodBudgetType: PERIOD_BUDGET_TYPE | null;
            readonly periodSettingIgnoreForBilling: boolean | null;
            readonly periodSettingSubtractValue: boolean | null;
            readonly periodSettingRollValue: boolean | null;
            readonly periodSettingAddExpenses: boolean | null;
            readonly periodDifferencePriceAmount: number | null;
            readonly periodDifferenceHoursAmount: number | null;
            readonly sharedPeriodDifferenceHoursAmount: number | null;
            readonly sharedPeriodDifferencePriceAmount: number | null;
            readonly ignoredRolloverHours: number | null;
            readonly ignoredRolloverPrice: number | null;
            readonly periodLocked: boolean | null;
            readonly periodLockedTime: string | null;
            readonly periodDifferenceSplit: boolean | null;
        } | null;
        readonly project: {
            readonly retainerPeriods: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly startYear: number | null;
                        readonly startMonth: number | null;
                        readonly startDay: number | null;
                        readonly endYear: number | null;
                        readonly endMonth: number | null;
                        readonly endDay: number | null;
                        readonly available: number | null;
                        readonly periodLength: number | null;
                        readonly periodPeriodicity: PERIODICITY | null;
                        readonly periodPriceAmount: number | null;
                        readonly periodHoursAmount: number | null;
                        readonly periodBudgetType: PERIOD_BUDGET_TYPE | null;
                        readonly periodSettingIgnoreForBilling: boolean | null;
                        readonly periodSettingSubtractValue: boolean | null;
                        readonly periodSettingRollValue: boolean | null;
                        readonly periodSettingAddExpenses: boolean | null;
                        readonly periodDifferencePriceAmount: number | null;
                        readonly periodDifferenceHoursAmount: number | null;
                        readonly sharedPeriodDifferenceHoursAmount: number | null;
                        readonly sharedPeriodDifferencePriceAmount: number | null;
                        readonly ignoredRolloverHours: number | null;
                        readonly ignoredRolloverPrice: number | null;
                        readonly periodLocked: boolean | null;
                        readonly periodLockedTime: string | null;
                        readonly periodDifferenceSplit: boolean | null;
                        readonly retainerPeriodRollovers: {
                            readonly edges: ReadonlyArray<{
                                readonly node: {
                                    readonly id: string;
                                    readonly periodFrom: {
                                        readonly id: string;
                                    } | null;
                                    readonly periodTo: {
                                        readonly id: string;
                                        readonly name: string | null;
                                    } | null;
                                    readonly amount: number | null;
                                } | null;
                            } | null> | null;
                        } | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type updateRetainerPeriodMutation = {
    readonly response: updateRetainerPeriodMutationResponse;
    readonly variables: updateRetainerPeriodMutationVariables;
};



/*
mutation updateRetainerPeriodMutation(
  $input: UpdateRetainerPeriodInput!
) {
  updateRetainerPeriod(input: $input) {
    errors
    retainerPeriod {
      id
      name
      startYear
      startMonth
      startDay
      endYear
      endMonth
      endDay
      available
      periodLength
      periodPeriodicity
      periodPriceAmount
      periodHoursAmount
      periodBudgetType
      periodSettingIgnoreForBilling
      periodSettingSubtractValue
      periodSettingRollValue
      periodSettingAddExpenses
      periodDifferencePriceAmount
      periodDifferenceHoursAmount
      sharedPeriodDifferenceHoursAmount
      sharedPeriodDifferencePriceAmount
      ignoredRolloverHours
      ignoredRolloverPrice
      periodLocked
      periodLockedTime
      periodDifferenceSplit
    }
    project {
      retainerPeriods(first: 100000) {
        edges {
          node {
            id
            name
            startYear
            startMonth
            startDay
            endYear
            endMonth
            endDay
            available
            periodLength
            periodPeriodicity
            periodPriceAmount
            periodHoursAmount
            periodBudgetType
            periodSettingIgnoreForBilling
            periodSettingSubtractValue
            periodSettingRollValue
            periodSettingAddExpenses
            periodDifferencePriceAmount
            periodDifferenceHoursAmount
            sharedPeriodDifferenceHoursAmount
            sharedPeriodDifferencePriceAmount
            ignoredRolloverHours
            ignoredRolloverPrice
            periodLocked
            periodLockedTime
            periodDifferenceSplit
            retainerPeriodRollovers(first: 100000) {
              edges {
                node {
                  id
                  periodFrom {
                    id
                  }
                  periodTo {
                    id
                    name
                  }
                  amount
                }
              }
            }
          }
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateRetainerPeriodInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "available",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodLength",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodPeriodicity",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodPriceAmount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodHoursAmount",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodBudgetType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodSettingIgnoreForBilling",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodSettingSubtractValue",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodSettingRollValue",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodSettingAddExpenses",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodDifferencePriceAmount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodDifferenceHoursAmount",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharedPeriodDifferenceHoursAmount",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharedPeriodDifferencePriceAmount",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ignoredRolloverHours",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ignoredRolloverPrice",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodLocked",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodLockedTime",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodDifferenceSplit",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "RetainerPeriodType",
  "kind": "LinkedField",
  "name": "retainerPeriod",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/)
  ],
  "storageKey": null
},
v31 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v32 = {
  "alias": null,
  "args": (v31/*: any*/),
  "concreteType": "RetainerPeriodTypeConnection",
  "kind": "LinkedField",
  "name": "retainerPeriods",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetainerPeriodTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RetainerPeriodType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/),
            (v27/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            {
              "alias": null,
              "args": (v31/*: any*/),
              "concreteType": "RetainerPeriodRolloverTypeConnection",
              "kind": "LinkedField",
              "name": "retainerPeriodRollovers",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RetainerPeriodRolloverTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RetainerPeriodRolloverType",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v3/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RetainerPeriodType",
                          "kind": "LinkedField",
                          "name": "periodFrom",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RetainerPeriodType",
                          "kind": "LinkedField",
                          "name": "periodTo",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v4/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "amount",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "retainerPeriodRollovers(first:100000)"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "retainerPeriods(first:100000)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateRetainerPeriodMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRetainerPeriodPayload",
        "kind": "LinkedField",
        "name": "updateRetainerPeriod",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v30/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v32/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateRetainerPeriodMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRetainerPeriodPayload",
        "kind": "LinkedField",
        "name": "updateRetainerPeriod",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v30/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v32/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateRetainerPeriodMutation",
    "operationKind": "mutation",
    "text": "mutation updateRetainerPeriodMutation(\n  $input: UpdateRetainerPeriodInput!\n) {\n  updateRetainerPeriod(input: $input) {\n    errors\n    retainerPeriod {\n      id\n      name\n      startYear\n      startMonth\n      startDay\n      endYear\n      endMonth\n      endDay\n      available\n      periodLength\n      periodPeriodicity\n      periodPriceAmount\n      periodHoursAmount\n      periodBudgetType\n      periodSettingIgnoreForBilling\n      periodSettingSubtractValue\n      periodSettingRollValue\n      periodSettingAddExpenses\n      periodDifferencePriceAmount\n      periodDifferenceHoursAmount\n      sharedPeriodDifferenceHoursAmount\n      sharedPeriodDifferencePriceAmount\n      ignoredRolloverHours\n      ignoredRolloverPrice\n      periodLocked\n      periodLockedTime\n      periodDifferenceSplit\n    }\n    project {\n      retainerPeriods(first: 100000) {\n        edges {\n          node {\n            id\n            name\n            startYear\n            startMonth\n            startDay\n            endYear\n            endMonth\n            endDay\n            available\n            periodLength\n            periodPeriodicity\n            periodPriceAmount\n            periodHoursAmount\n            periodBudgetType\n            periodSettingIgnoreForBilling\n            periodSettingSubtractValue\n            periodSettingRollValue\n            periodSettingAddExpenses\n            periodDifferencePriceAmount\n            periodDifferenceHoursAmount\n            sharedPeriodDifferenceHoursAmount\n            sharedPeriodDifferencePriceAmount\n            ignoredRolloverHours\n            ignoredRolloverPrice\n            periodLocked\n            periodLockedTime\n            periodDifferenceSplit\n            retainerPeriodRollovers(first: 100000) {\n              edges {\n                node {\n                  id\n                  periodFrom {\n                    id\n                  }\n                  periodTo {\n                    id\n                    name\n                  }\n                  amount\n                }\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e0f804c7678b60cf62a68a5d959ca75e';
export default node;
